// Theme configuration for styled-components
export const theme = {
  // Color palette
  colors: {
    primary: '#FFD700', // Yellow - Used for highlights and primary actions
    secondary: '#800080', // Purple - Used for secondary elements and accents
    secondarylight: '#f5ebf5', // Purple - Used for secondary elements and accents
    black: '#000000',
    white: '#FFFFFF',
    background: '#F8F9FA', // Light background color
    gray: {
      lightest: '#F5F5F5', // Used for form fields
      light: '#F8F9FA', // Used for subtle backgrounds
      medium: '#6C757D', // Used for secondary text
      dark: '#343A40', // Used for primary text
    },
  },

  // Typography settings
  fonts: {
    primary: "'Roboto', sans-serif", // Main font for body text
    secondary: "'Playfair Display', serif", // Used for headings
  },

  // Responsive breakpoints
  breakpoints: {
    mobile: '480px', // Small devices
    tablet: '768px', // Medium devices
    laptop: '1279px', // Large devices
    desktop: '1280px', // Extra large devices
  },

  // Animation settings
  transitions: {
    default: 'all 0.3s ease', // Default transition for hover effects
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '2rem',
    xl: '4rem',
  },
};

export default theme;
